import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import WorkListView from 'src/sections/user/view/work-list-view';
import NewPage from '../../sections/newPage/NewPage';
import DateContextProvider from 'src/sections/user/view/Context/DateContext';

// import { element } from 'prop-types';
// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));

// PRODUCT

// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
const UserCardsPage = lazy(() => import('src/pages/dashboard/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/new'));
const UserEditPage = lazy(() => import('src/pages/dashboard/user/edit'));
const NewPages = lazy(() => import('src/pages/NewPageView/newPage'));

// BLOG

// JOB

// TOUR

// APP

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <DashboardLayout>
        <DateContextProvider>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
        </DateContextProvider>
      </DashboardLayout>
    ),
    children: [
      { element: <IndexPage />, index: true },

      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          { path: 'cards', element: <UserCardsPage /> },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
          { path: 'newtt', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
          { path: 'account', element: <UserAccountPage /> },
        ],
      },
      {
        path: 'work_request',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'new', element: <UserCreatePage /> },
          { path: 'list', element: <UserListPage /> },

          { path: 'listView', element: <WorkListView /> },
        ],
      },
      {
        path: 'newPage',
        children: [{ element: <NewPage />, index: true }],
      },
    ],
  },
];
